<template>
  <button
    v-on="$listeners"
    v-bind="$attrs"
    class="app-button app-button--magenta ripple"
    :class="inverted && 'inverted'"
    data-jest="app-button"
  >
    <slot>Enviar</slot>
  </button>
</template>

<script>
export default {
  name: 'AppButton',

  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.app-button.app-button--magenta {
  color: #fff;
  border: none;
  background-color: var(--c-magenta-500);
}

.app-button.app-button--magenta.inverted {
  color: var(--c-magenta-500);
  border: 1px solid var(--c-magenta-500);
  background-color: #fff;
}

.app-button--magenta:not(:disabled):hover {
  background-color: var(--c-magenta-800);
}

.app-button--magenta.inverted:hover {
  color: #fff;
  border-color: transparent;
  background-color: var(--c-magenta-500);
}

/* Ripple effect */
.app-button--magenta.ripple {
  --r-hover-bg: var(--c-magenta-500);
  --r-active-bg: var(--c-magenta-300);
  --r-transition: all 0.6s;
}

/* Ripple effect inverted */
.app-button--magenta.ripple.inverted {
  --r-hover-bg: var(--c-magenta-300);
  --r-active-bg: var(--c-magenta-300);
}
</style>
